import { registrar_entrega_de_relatorio_final_da_escola } from "./registrar-entrega-de-relatorio-final-da-escola";
import { registrar_observacao_relatorio_final_turma } from "./registrar-observacao-relatorio-final-turma";
import { arquivar_relatorio_final_da_escola } from "./arquivar-relatorio-final-da-escola";
import { cancelar_entrega_de_relatorio_final_da_escola } from "./cancelar-entrega-de-relatorio-final-da-escola";
import { impressao_de_analise_de_relatorio_final } from "./impressao-de-analise-de-relatorio-final";
import { parametrizacao_de_prazo_de_encerramento } from "./parametrizacao-de-prazo-de-encerramento";
import { resumo_da_entrega_dos_relatorios_finais } from "./resumo-da-entrega-dos-relatorios-finais";
import { autorizar_correcao_em_relatorio_final_da_escola } from "./autorizar-correcao-em-relatorio-final-da-escola";

const relatorio_final_da_escola = [
  ...registrar_entrega_de_relatorio_final_da_escola,
  ...registrar_observacao_relatorio_final_turma,
  ...arquivar_relatorio_final_da_escola,
  ...cancelar_entrega_de_relatorio_final_da_escola,
  ...impressao_de_analise_de_relatorio_final,
  ...parametrizacao_de_prazo_de_encerramento,
  ...resumo_da_entrega_dos_relatorios_finais,
  ...autorizar_correcao_em_relatorio_final_da_escola,
];

export { relatorio_final_da_escola };
